document.addEventListener("DOMContentLoaded", () => {
  var thimbs = new Swiper(".thimbs-slider", {
    loop: true,
    spaceBetween: 12,
    slidesPerView: 7,
    speed: 2800,
    watchSlidesProgress: true,
  });
  var subscribeSlider = new Swiper(".subscribe-slider", {
    loop: true,
    spaceBetween: 12,
    slidesPerView: 1,
    speed: 2800,
    autoplay: {
      delay: 5000,
    },
    thumbs: {
      swiper: thimbs,
    },
  });

  const excellenceSlider = new Swiper(".excellence-slider", {
    loop: true,
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 44,
    speed: 1800,
    autoplay: {
      delay: 5000,
    },
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  const recallSlider = new Swiper(".recall-slider", {
    // loop: true,
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 44,
    speed: 1500,
    autoHeight: true,
    navigation: {
      nextEl: ".recall-button-next",
      prevEl: ".recall-button-prev",
    },
  });
});
